import * as React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { ICON_TO_TOP } from '../_style';
import { Box, Zoom, Fab, useScrollTrigger } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  top: {
    position: 'fixed',
    bottom: 60,
    right: 60,
    zIndex: 1200,
    [theme.breakpoints.down('md')]: {
      bottom: 100,
      right: 20,
    },
    '@media print': {
      display: 'none',
    },
  },
  icon: {
    color: theme.palette.primary.text,
  },
  Fab: {
    boxShadow: theme.palette.button.shadow.main,
    '&:hover': {
      boxShadow: 'none',
    },
  },
}));


const ScrollTop = (props) => {

  const classes = useStyles();
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 500,
  });

  const onClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      '#backToTop',
    );
    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };


  return (
    <Zoom in={trigger}>
      <Box
        className={classes.top}
        onClick={onClick}
        role='presentation'
      >
        {children}
      </Box>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};


/** 回到頂端 */
export function ScrolltoTop(){

  const classes = useStyles();


  return (
    <>
    
      <div id='backToTop' />

      <ScrollTop>
        <Fab color='primary' size='small' aria-label='scroll back to top' className={classes.Fab} id='backToTopBtn'>
          <ICON_TO_TOP classes={classes.icon} size={{box: 'l', svg: 'l'}} />
        </Fab>
      </ScrollTop>

    </>
  )
}